import React from "react"
import { Grid } from "@material-ui/core"
import { Text, themeColors } from "letalkui"

import {
	Person as RoleIcon
} from "@material-ui/icons"

import useStyles from "@/pages/Admin/Role/RoleList/RoleListItem/RoleListIdentity/styles"

type RoleListIdentityProps = {
	name: string
}

const RoleListIdentity: React.FC<RoleListIdentityProps> = (props) => {
	const { name } = props

	const classes = useStyles()

	return (
		<Grid container spacing={1} alignItems="center" justifyContent="flex-start">
			<Grid item xs={3}>
				<Grid container justifyContent="center">
					<RoleIcon fontSize="large" style={{ color: themeColors.getPrimaryColor() }}/>
				</Grid>
			</Grid>
			<Grid item xs={9}>
				<Grid container justifyContent="flex-start">
					<Text.Body type="default" sx={classes.listItemTitle} fontWeight="bold">
						{name}
					</Text.Body>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default RoleListIdentity
